document.addEventListener('click', function(event) {
  const opener = event.target.closest('[data-miuur-drawer-open]');

  if (opener) {
    const id = opener.getAttribute('data-miuur-drawer-open');
    const dialog = document.querySelector(
      '[data-miuur-drawer="' + id + '"]'
    );

    if (!dialog) return;

    dialog.showModal();

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        dialog.classList.add('is-open');
      });
    });

    return;
  }

  const closeButton = event.target.closest(
    '[data-miuur-drawer-close]'
  );

  if (closeButton) {
    closeMiuurDrawer(
      closeButton.closest('.miuur-product-drawer')
    );
  }
});


document.addEventListener('click', function(event) {
  const dialog = event.target.closest('.miuur-product-drawer');

  if (!dialog) return;

  if (event.target === dialog) {
    closeMiuurDrawer(dialog);
  }
});


document.addEventListener('cancel', function(event) {
  const dialog = event.target;

  if (!dialog.classList.contains('miuur-product-drawer')) {
    return;
  }

  event.preventDefault();
  closeMiuurDrawer(dialog);
}, true);


function closeMiuurDrawer(dialog) {
  if (!dialog) return;

  dialog.classList.remove('is-open');

  setTimeout(function() {
    if (dialog.open) {
      dialog.close();
    }
  }, 480);
}